import { Component, ChangeDetectionStrategy, signal, inject, computed, OnInit, ɵgetUnknownElementStrictMode } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ServiceNode } from '../../types/service-node';
import { M_SRMASTER } from '../../types/M_SRMASTER';
import { ServiceManagementService } from '../../services/service-management.service';
import { MasterService } from '@/src/services/master.service';
import { AuthenticationService } from '@/src/services/authentication.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Constants } from '@/src/helpers/constants';
import { CheckboxModule } from 'primeng/checkbox';
import { PopUpCommonComponent } from '@/src/components/pop-up-common/pop-up-common.component'
import { InputNumber } from 'primeng/inputnumber';
import { InputText } from "primeng/inputtext";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-service-settings',
  standalone: true,
  imports: [FormsModule, TranslateModule, CheckboxModule, PopUpCommonComponent, InputNumber, InputText, InputText, CommonModule],
  templateUrl: './service-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceSettingsComponent implements OnInit {
  private serviceManagementService = inject(ServiceManagementService);
  private masterService = inject(MasterService);
  private auth = inject(AuthenticationService)
  private translate = inject(TranslateService)

  main = 1;
  sub = 2;
  ser = 3;

  showConfirmDelete = signal<boolean>(false);

  activeTab = signal<'SERVICE' | 'OPTION'>('SERVICE');

  mainservices = signal<M_SRMASTER[]>([]);
  subServices = signal<M_SRMASTER[]>([]);
  services = signal<M_SRMASTER[]>([]);

  headerMainChecked: boolean = false;
  headerSubChecked: boolean = false;
  headerServiceChecked: boolean = false;

  serviceTree = signal<ServiceNode[]>([]);
  optionTree = signal<ServiceNode[]>([]);

  selectedGroup = signal<M_SRMASTER | null>(new M_SRMASTER());
  selectedCategory = signal<M_SRMASTER | null>(new M_SRMASTER());
  selectedService = signal<M_SRMASTER | null>(new M_SRMASTER());

  sameMainServiceChecked: boolean = true;
  sameMainOptionChecked: boolean = true;

  checkedMainCount(): number {
    return this.mainservices().filter(x => x.checked).length;
  }

  checkedSubCount(): number {
    return this.subServices().filter(x => x.checked).length;
  }

  checkedSerCount(): number {
    return this.services().filter(x => x.checked).length;
  }

  isLoading = signal(true);

  param = {
    P_HQ_CD: '',
    P_STR_CD: '',
    P_LCLASS_CD: '',
    P_SCLASS_CD: '',
    Old_P_L_CLASS_CD: "",
    Old_P_S_CLASS_CD: ""
  }

  ngOnInit() {
    this.param.P_HQ_CD = this.auth.getHQCD();
    this.param.P_STR_CD = this.auth.getStrCd();
    this.getMainService();
    // setTimeout(() => {
    //    this.optionTree.set(this.serviceManagementService.getOptionTree()());
    //   this.serviceTree.set(this.serviceManagementService.getServiceTree()());
    // }, 500);
  }

  changeTab(tab: 'SERVICE' | 'OPTION') {
    this.activeTab.set(tab);
    this.getMainService();
  }

  getMainService() {
    this.selectedGroup.set(null);
    this.selectedCategory.set(null);
    this.selectedService.set(null);
    this.mainservices.set([]);
    this.subServices.set([]);
    this.services.set([]);

    this.headerMainChecked = false;
    this.headerSubChecked = false;
    this.headerServiceChecked = false;
    this.isLoading.set(true);
    this.param.Old_P_L_CLASS_CD = '';
    this.param.Old_P_S_CLASS_CD = '';
    const param = {
      Type: this.activeTab()
    }
    this.serviceManagementService.getService(param).subscribe((res: any) => {
      if (res?.isOK) {
        this.mainservices.set(res?.result?.dataRes)
      }
      this.isLoading.set(false);
    })
  }

  getSubService(lClassCd: string, isSave: boolean = false) {
    this.param.P_LCLASS_CD = lClassCd;
    if (!isSave) {
      if (this.param.P_LCLASS_CD === this.param.Old_P_L_CLASS_CD) return;
      else this.param.Old_P_L_CLASS_CD = this.param.P_LCLASS_CD;
    }
    this.subServices.set([]);
    this.services.set([]);
    this.selectedService.set(null)
    //SP_STR_GET_SCLASS
    this.masterService.excute_sp('6a839f77-298d-11f1-9014-00155d001e02', this.param).subscribe((res: any) => {
      if (res?.isOK) {
        this.selectedCategory.set(null);
        this.subServices.set(res?.result?.dataRes[0]?.rows);
      }
    })
  }

  getService(sClassCd: string, isSave: boolean = false) {
    this.param.P_LCLASS_CD = this.selectedGroup().l_CLASS_CD;
    this.param.P_SCLASS_CD = sClassCd;
    if (this.param.P_SCLASS_CD === this.param.Old_P_S_CLASS_CD && this.param.P_LCLASS_CD === this.param.Old_P_S_CLASS_CD && !isSave) return;
    else {
      this.param.Old_P_S_CLASS_CD = this.param.P_SCLASS_CD;
      this.param.Old_P_L_CLASS_CD = this.param.P_LCLASS_CD;
    }
    this.services.set([]);
    //SP_STR_GET_SERVICE
    this.masterService.excute_sp('6a839fab-298d-11f1-9014-00155d001e02', this.param).subscribe((res: any) => {
      if (res?.isOK) {
        this.selectedService.set(null)
        this.services.set(res?.result?.dataRes[0]?.rows);
      }
    })
  }

  selectGroup(service: M_SRMASTER) {
    this.selectedGroup.set(service);
    if (service.hQ_CD) {
      this.getSubService(service.l_CLASS_CD)
    }
    else {
      this.param.Old_P_L_CLASS_CD = '';
      this.param.Old_P_S_CLASS_CD = '';
      this.selectedCategory.set(null);
      this.selectedService.set(null);
      this.subServices.set([]);
      this.services.set([]);
    }
  }

  selectCategory(service: M_SRMASTER) {
    this.selectedCategory.set(service);
    if (service.hQ_CD) {
      this.getService(service.s_CLASS_CD);
    }
    else {
      this.param.Old_P_S_CLASS_CD = '';
      this.selectedService.set(null);
      this.services.set([]);
    }
  }

  selectService(service: M_SRMASTER) {
    this.selectedService.set(service);
  }

  updateNodeValue(type: 'GROUP' | 'CATEGORY' | 'PRODUCT', id: string, field: keyof ServiceNode, value: any) {
    if (type === 'GROUP') {
      this.mainservices.update(main => {
        const group = main.find(g => g.l_CLASS_CD === id);
        if (group) (group as any)[field] = value;
        return main;
      })
    }
    else if (type === 'CATEGORY') {
      this.subServices.update(sub => {
        const group = sub.find(g => g.s_CLASS_CD === id);
        if (group) (group as any)[field] = value;
        return sub;
      })
    }
    else {
      this.services.update(ser => {
        const group = ser.find(g => g.servicE_CD === id);
        if (group) (group as any)[field] = value;
        return ser;
      })
    }
  }

  newService(type: number) {
    const maxMain = this.mainservices().length > 0
      ? Math.max(...this.mainservices().map(x => Number(x.l_CLASS_CD?.substring(2))))
      : 0;

    const maxSortMain = this.mainservices().length > 0
      ? Math.max(...this.mainservices().map(x => Number(x.sort)))
      : 0;

    const maxSub = this.subServices().length > 0
      ? Math.max(...this.subServices().map(x => Number(x.s_CLASS_CD?.substring(2))))
      : 0;

    const maxSortSub = this.subServices().length > 0
      ? Math.max(...this.subServices().map(x => Number(x.sort)))
      : 0;

    const maxSer = this.services().length > 0
      ? Math.max(...this.services().map(x => Number(x.servicE_CD?.substring(2))))
      : 0;

    const maxSortSer = this.services().length > 0
      ? Math.max(...this.services().map(x => Number(x.sort)))
      : 0;

    const next = (type == this.main ? maxMain + 1 : type == this.sub ? maxSub + 1 : maxSer + 1).toString().padStart(8, '0');
    const code = type == this.main ? `LX${next}` : type == this.sub ? `SX${next}` : `EX${next}`;

    const item = new M_SRMASTER();
    item.checked = true;
    const sameMainCheck = this.activeTab() == 'SERVICE' ? this.sameMainServiceChecked : this.sameMainOptionChecked;
    switch (type) {
      case this.main:
        item.l_CLASS_CD = code;
        item.serviceType = this.main;
        item.sort = maxSortMain + 1;
        this.subServices.set([])
        this.services.set([])
        this.param.Old_P_L_CLASS_CD = '';
        this.selectedGroup.set(item);
        // item.sR_TP = this.SRTPList.length > 0 ? this.SRTPList[0].comM_D_CD : '';
        this.mainservices.update(main => {
          main.unshift(item);
          return main;
        })
        break;
      case this.sub:
        item.l_CLASS_CD = this.selectedGroup().l_CLASS_CD;
        item.s_CLASS_NM = sameMainCheck === true ? this.selectedGroup().l_CLASS_NM : '';
        item.s_CLASS_CD = code;
        item.sort = maxSortSub + 1;
        item.serviceType = this.sub;
        this.selectedCategory.set(item)
        this.services.set([])
        this.param.Old_P_S_CLASS_CD = '';
        this.subServices.update(sub => {
          sub.unshift(item);
          return sub;
        })
        break;
      default:
        item.l_CLASS_CD = this.selectedGroup().l_CLASS_CD;
        item.s_CLASS_CD = this.selectedCategory().s_CLASS_CD;
        item.servicE_CD = code;
        item.sort = maxSortSer + 1;
        item.serviceType = this.ser;
        this.selectedService.set(item)
        this.services.update(ser => {
          ser.unshift(item);
          return ser;
        })
        break;
    }
  }

  addNode(type: 'GROUP' | 'CATEGORY' | 'PRODUCT') {
    // const setTree = this.activeTab() === 'SERVICE' ? this.serviceTree : this.optionTree;
    if (type === 'GROUP') {
      this.mainservices.update(main => {
        main.push(new M_SRMASTER())
        return main;
      })
    }
    else if (type === 'CATEGORY') {
      this.subServices.update(sub => {
        sub.push(new M_SRMASTER())
        return sub;
      })
    }
    else {
      this.services.update(ser => {
        ser.push(new M_SRMASTER())
        return ser;
      })
    }
  }

  saveService(type: number, action: string = '') {
    let param: any = {}
    let message = '';
    message = type == this.main ? 'SERVCEHQ0020' : type == this.sub ? 'SERVCEHQ0021' : 'SERVCEHQ0022';
    if (action === 'delete') {
      this.mainservices.update(list => {
        if (type === this.main) {
          return list.filter(x => x.hQ_CD !== '');
        }
        return list;
      });

      this.subServices.update(list => {
        if (type === this.sub) {
          return list.filter(x => x.hQ_CD !== '');
        }
        return list;
      });

      this.services.update(list => {
        if (type === this.ser) {
          return list.filter(x => x.hQ_CD !== '');
        }
        return list;
      });
    }
    const checkedMainservice = this.mainservices().filter(x => x.checked);
    const checkedSubservice = this.subServices().filter(x => x.checked);
    const checkedServices = this.services().filter(x => x.checked);
    if (action === 'delete') {
      if (type === this.main) {
        if (checkedMainservice.length <= 0) return;
        // checkedMainservice.forEach(x => {
        //   if (action === 'delete') x.usE_YN = 'N';
        // });
      } else if (type === this.sub) {
        if (checkedSubservice.length <= 0) return;

        // checkedSubservice.forEach(x => {
        //   if (action === 'delete') x.usE_YN = 'N';
        // });
      } else if (type === this.ser) {
        if (checkedServices.length <= 0) return;
        // checkedServices.forEach(x => {
        //   if (action === 'delete') x.usE_YN = 'N';
        // });
      }

      message = 'SYSMESER0007';
    }

    param = {
      type: type,
      action: action == 'delete' ? 'delete' : 'update',
      sr_tp: this.activeTab() === 'SERVICE' ? 0 : 1,
      data: type == this.main ? checkedMainservice :
        type == this.sub ? checkedSubservice :
          checkedServices
    }

    message = action == 'delete' ? 'SYSMESER0007' : message;

    if ((type === this.main && checkedMainservice[0]?.hQ_CD) || (type === this.sub && checkedSubservice[0]?.hQ_CD) || (type === this.ser && checkedServices[0]?.hQ_CD)) {
      message = 'SYSMESER0006'
    }
    this.serviceManagementService.post(param).subscribe((res: any) => {
      if (res?.isOK) {
        this.param.Old_P_L_CLASS_CD = type == this.main ? '' : this.param.Old_P_L_CLASS_CD;
        this.param.Old_P_S_CLASS_CD = type == this.sub ? '' : this.param.Old_P_S_CLASS_CD;
        if (type === this.main) {
          this.headerMainChecked = false;
          this.getMainService();
          this.param.Old_P_L_CLASS_CD = '';
          this.param.Old_P_S_CLASS_CD = '';
        }
        if (type === this.sub) {
          this.getSubService(this.selectedGroup()?.l_CLASS_CD, true);
          this.headerSubChecked = false;
        }
        if (type === this.ser) {
          this.getService(this.selectedCategory()?.s_CLASS_CD, true);
          this.headerServiceChecked = false;
        }
        this.masterService.showSuccess(this.translate.instant(message))
      } else {
        this.masterService.showError(Constants.showError(res?.errorMessages))
      }
    }
    )
  }

  typeDelete: number = 0;
  confirmDelete(typeDelete: number) {
    this.typeDelete = typeDelete;
    const checkedMainservice = this.mainservices().filter(x => x.checked);
    const checkedSubservice = this.subServices().filter(x => x.checked);
    const checkedServices = this.services().filter(x => x.checked);

    if (typeDelete === this.main && checkedMainservice.length <= 0) return;
    else if (typeDelete === this.sub && checkedSubservice.length <= 0) return;
    else if (typeDelete === this.ser && checkedServices.length <= 0) return;

    this.showConfirmDelete.set(true);
  }

  delete() {
    this.showConfirmDelete.set(false);
    this.saveService(this.typeDelete, 'delete')
  }

  checkedAll(type: number) {
    if (type == this.main) {
      this.mainservices.update(list => {
        list.forEach(element => {
          element.checked = this.headerMainChecked ? true : false;
        });
        return list;
      })
    }
    else if (type == this.sub) {
      this.subServices.update(list => {
        list.forEach(element => {
          element.checked = this.headerSubChecked ? true : false;
        });
        return list;
      })
    }
    else {
      this.services.update(list => {
        list.forEach(element => {
          element.checked = this.headerServiceChecked ? true : false;
        });
        return list;
      })
    }
  }

  changeCheck(type: number) {
    const checkedMainservice = this.mainservices().filter(x => x.checked);
    const checkedSubservice = this.subServices().filter(x => x.checked);
    const checkedServices = this.services().filter(x => x.checked);

    this.headerMainChecked = type === this.main ? checkedMainservice.length === this.mainservices().length : this.headerMainChecked
    this.headerSubChecked = type === this.sub ? checkedSubservice.length === this.subServices().length : this.headerSubChecked
    this.headerServiceChecked = type === this.ser ? checkedServices.length === this.services().length : this.headerServiceChecked
  }
}
